import type { EntityGraphNode } from "../../../../core/engine/EntityGraphNode/EntityGraphNode.type"
import type { SwampEntity } from "../../../../core/entity/EntityType/Swamp"
import getManhattanDistance from "../../../../core/tile_position_xy/getManhattanDistance"

type SwampCluster = Array<EntityGraphNode<SwampEntity>>
type SwampClusterList = Array<SwampCluster>

// Step 1: Create initial clusters based on adjacency
export default function createInitialSwampClusters(
  entities: SwampCluster
): SwampClusterList {
  const visited = new Set<number>()
  const chunks: SwampClusterList = []

  function floodFill(start: EntityGraphNode<SwampEntity>, cluster: SwampCluster) {
    const stack = [start]
    visited.add(start.id)

    while (stack.length > 0) {
      const currentEntNode = stack.pop()!
      const currentEnt = currentEntNode.raw()
      cluster.push(currentEntNode)

      for (const otherEntNode of entities) {
        if (!visited.has(otherEntNode.id) && getManhattanDistance(currentEnt, otherEntNode.raw()) === 1) {
          visited.add(otherEntNode.id)
          stack.push(otherEntNode)
        }
      }
    }
  }

  for (const entityNode of entities) {
    if (!visited.has(entityNode.id)) {
      const cluster: SwampCluster = []
      floodFill(entityNode, cluster)
      chunks.push(cluster)
    }
  }
  return chunks
}